export const color = {
  white: "#ffffff",
  black: "#000000",
  red: "#FF0000"
};

export const spacing = {
  extraSmall: "5px",
  small: "15px",
  medium: "35px",
  large: "65px",
  initial: "initial",
};

export const width = {
  small: "30px",
  medium: "100px",
  large: "250px",
};

export const borderRadius = {
  small: "3px",
  large: "5px",
};

export const fontFamily = {
  serif: "EB Garamond",
  sansSerif: "Roboto",
  sansSerifCondensed: "Roboto Condensed",
};

export const fontSize = {
  small: "12px",
  medium: "16px",
  large: "18px",
  huge: "64px",
};

export const fontWeight = {
  regular: 400,
  bold: 600,
};
